import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import PhasesList from './PhasesList/PhasesList';
import PhaseCreate from './PhaseCreate/PhaseCreate';
import PhaseEdit from './PhaseEdit/PhaseEdit';
import PhaseDelete from './PhaseDelete/PhaseDelete';

const Phases = ({ match }) => {
    return (
        <div className="Phases">
            <ContainerWrapper container="phases">
                <Route exact path={ match.path } component={PhasesList} />
                <Route exact path={ `${ match.url }/new` } component={PhaseCreate} />
                <Route exact path={ `${ match.url }/edit/:phaseId` } component={PhaseEdit} />
                <Route exact path={ `${ match.url }/delete/:phaseId` } component={PhaseDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Phases;
